<div class="flex flex-col justify-center items-center text-center w-100 mt-3">
	<small class="text-[10px]">
		<span>The Coffee Bara ® 2025</span>
		@if (versionService.version) {
		<span>| Versión {{ versionService.version }}</span>
		}
	</small>
	<small class="text-[9px]">Todos los derechos reservados</small>
</div>
